export default {
    title: 'Nawyki',
    subtitle: 'Dziś {done} z {total}',
    newHabit: 'Nowy nawyk',
    today: {
        title: 'Dziś',
        nothing: 'Na dziś nie ma wymaganych nawyków.',
    },
    other: {
        title: 'Nie dziś',
    },
    empty: {
        title: 'Jeszcze bez nawyków',
        text: 'Dodaj pierwszy — np. wodę, czytanie albo spacer — i odhaczaj go każdego dnia.',
    },
    archive: {
        title: 'Archiwum',
        empty: 'Nic tu nie ma.',
    },
    pick: {
        title: 'Wybierz nawyk',
        text: 'Zobaczysz jego serię, skuteczność i ostatnie tygodnie — i zmienisz, co trzeba.',
    },
    toolbar: {
        back: 'Wróć do listy',
        archived: 'W archiwum',
        archive: 'Do archiwum',
        restore: 'Przywróć',
        remove: 'Usuń nawyk',
    },
    toast: {
        saved: 'Zapisane.',
        archived: '„{name}" w archiwum.',
        restored: '„{name}" znów na liście.',
        removed: 'Usunięto „{name}".',
    },
    goal: 'cel: {target} {unit}',
    notToday: 'dziś niewymagany',
    week: 'w tym tygodniu {done} z {times}',
    control: {
        check: 'Odhacz: {name}',
        undo: 'Cofnij odhaczenie: {name}',
        minus: 'Odejmij 1: {name}',
        plus: 'Dodaj 1: {name}',
    },
    numbers: {
        title: 'Jak idzie',
        streak: 'Seria',
        best: 'Najdłuższa seria',
        rate: 'Skuteczność 30 dni',
    },
    streak: {
        days: '{n} dzień | {n} dni | {n} dni',
        weeks: '{n} tydzień | {n} tygodnie | {n} tygodni',
    },
    grid: {
        title: 'Ostatnie 16 tygodni',
        states: {
            done: 'zaliczony',
            partial: 'częściowo',
            missed: 'pominięty',
            today: 'dziś, jeszcze nie',
            off: 'niewymagany',
            before: 'przed początkiem',
            future: 'jeszcze przed nami',
        },
        legend: {
            done: 'zaliczony',
            partial: 'częściowo',
            missed: 'pominięty',
            off: 'niewymagany',
        },
    },
    edit: {
        title: 'Ustawienia nawyku',
    },
    kinds: {
        check: 'Tak/nie',
        count: 'Do celu',
    },
    schedule: {
        daily: 'Codziennie',
        weekdays: 'Wybrane dni',
        times_per_week: 'Kilka razy w tygodniu',
        dailyLabel: 'codziennie',
        timesLabel: '{n} raz w tygodniu | {n} razy w tygodniu | {n} razy w tygodniu',
    },
    form: {
        suggestions: 'Podpowiedzi',
        icon: 'Emoji',
        iconHint: 'Emoji przy nazwie (opcjonalnie)',
        name: 'Nazwa',
        namePlaceholder: 'Np. Woda, Czytanie, Spacer…',
        kind: 'Rodzaj',
        targetPrefix: 'Cel dnia:',
        target: 'Cel dnia',
        unit: 'Jednostka',
        unitPlaceholder: 'np. szklanki',
        schedule: 'Rytm',
        times: 'Ile razy w tygodniu',
        timesSuffix: 'raz w tygodniu | razy w tygodniu | razy w tygodniu',
        reminder: 'Przypomnienie',
        noReminder: 'Bez',
        remindAt: 'O godzinie',
        remindTime: 'Godzina przypomnienia',
        reminderHint: 'Powiadomienie przyjdzie tylko, gdy nawyk jest dziś wymagany i jeszcze nieodhaczony (włączasz je w Planer → Ustawienia).',
        save: 'Zapisz zmiany',
        add: 'Dodaj nawyk',
        cancel: 'Anuluj',
    },
    suggestions: {
        water: { label: 'Woda — 8 szklanek', name: 'Woda', unit: 'szklanki' },
        reading: { label: 'Czytanie — 20 stron', name: 'Czytanie', unit: 'stron' },
        stretching: { label: 'Rozciąganie', name: 'Rozciąganie' },
        sweets: { label: 'Bez słodyczy', name: 'Bez słodyczy' },
        walk: { label: 'Spacer', name: 'Spacer' },
        meditation: { label: 'Medytacja', name: 'Medytacja' },
    },
    planner: {
        title: 'Nawyki dnia',
        open: 'Otwórz Nawyki',
    },
    help: {
        today: {
            title: 'Dziś',
            text: 'Nawyki wymagane dziś: kliknij kółko, żeby odhaczyć, albo −/+ przy celu ilościowym. 🔥 to seria.',
            more: 'Dzień jest zaliczony, gdy odhaczysz nawyk tak/nie albo dojdziesz do celu (np. 8 z 8 szklanek). Pominięty dzień nie robi się zaległy — tylko przerywa serię. Dzisiejszy, jeszcze nieodhaczony, serii nie przerywa.',
        },
        other: {
            title: 'Nie dziś',
            text: 'Nawyki, których rytm nie wymaga dziś — np. tylko w poniedziałki albo już zrobione 3 razy w tym tygodniu.',
            more: 'Możesz je odhaczyć i tak — liczy się to do historii, a przy „N razy w tygodniu" do tygodnia.',
        },
        add: {
            title: 'Nowy nawyk',
            text: 'Nazwa, rodzaj (tak/nie albo do celu), rytm i — jeśli chcesz — godzina przypomnienia.',
            more: 'Asystent też doda nawyk, gdy wprost poprosisz: „chcę codziennie pić 8 szklanek wody". A „wypiłem 2 szklanki wody" odhaczy go za ciebie.',
        },
        grid: {
            title: 'Ostatnie tygodnie',
            text: 'Każdy kwadrat to dzień: zielony — zaliczony, jaśniejszy — część celu, szary — pominięty, pusty — niewymagany.',
            more: 'Kliknij dzień, żeby go dopisać po fakcie (przy celu ilościowym dodaje 1, przy tak/nie przełącza).',
        },
        numbers: {
            title: 'Jak idzie',
            text: 'Seria — ile wymaganych dni (albo tygodni) z rzędu. Najdłuższa — rekord. Skuteczność — ile wymaganych dni z ostatnich 30 udało się zaliczyć.',
            more: 'Przy rytmie „N razy w tygodniu" liczą się tygodnie, a bieżący tydzień w toku serii nie przerywa.',
        },
        schedule: {
            title: 'Rytm',
            text: 'Codziennie, w wybrane dni tygodnia albo N razy w tygodniu, w dowolne dni.',
            more: 'W dni spoza rytmu nawyk nie jest wymagany i nie przerywa serii.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Nawykach',
            description: 'Rzeczy, które chcesz robić regularnie — odhaczasz je każdego dnia od nowa, a seria rośnie.',
        },
        habit: {
            title: 'Nawyk',
            description: 'Po kliknięciu nawyku: seria, najdłuższa seria, skuteczność, siatka ostatnich tygodni i ustawienia. Tam też archiwum i usuwanie.',
        },
        end: {
            title: 'To wszystko',
            description: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. Nawyki dnia widzisz też w Planerze.',
        },
    },
    firstSteps: {
        habit: {
            title: 'Pierwszy nawyk',
            action: 'Dodaj nawyk',
            what: 'Kliknij „Nowy nawyk" i wybierz podpowiedź albo wpisz własny.',
            why: 'Od tego zaczyna się seria — nawyk pokaże się w „Dziś" i w Planerze.',
        },
        log: {
            title: 'Pierwsze odhaczenie',
            action: 'Odhacz',
            what: 'Kliknij kółko przy nawyku (albo + przy celu ilościowym).',
            why: 'Każdy zaliczony dzień wydłuża serię.',
        },
        count: {
            title: 'Nawyk do celu',
            action: 'Dodaj wodę',
            what: 'Dodaj nawyk z celem, np. „Woda — 8 szklanek", i dodawaj po jednej.',
            why: 'Widzisz „3/8" i wiesz, ile jeszcze zostało na dziś.',
        },
        streak3: {
            title: 'Seria 3',
            action: 'Zobacz serię',
            what: 'Zalicz nawyk trzy wymagane dni z rzędu.',
            why: 'Trzy dni to pierwszy próg — dalej robi się już łatwiej.',
        },
    },
};
